import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UtilsModule } from '@tablesready/common-ui';
import { DateFormatPipe } from '@tablesready/frontend-pipes';

import { SmsUsageComponent } from './sms-usage.component';

@NgModule({
  declarations: [SmsUsageComponent],
  imports: [CommonModule, UtilsModule, DateFormatPipe],
  exports: [
    SmsUsageComponent,
  ],
})
export class SmsUsageModule {}
